import competency from "./Competency/reducer";
import employee from "./Employee/reducer";
import idp from "./Idp/reducer";
import { combineReducers } from "redux";

const growthPath = combineReducers({
  competency,
  employee,
  idp,
});

export default growthPath;
